import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-10.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-11.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-3.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-4.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-5.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-6.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-7.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-8.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-9.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
